export default function CtaSection() {
  return (
    <section
      id="cta"
      className="relative py-20 md:py-28 overflow-hidden"
      style={{
        background: 'linear-gradient(135deg, #1a1a1a 0%, #2a1a00 50%, #1a1a1a 100%)',
        borderTop: '1px solid rgba(245,166,35,0.2)',
      }}
      aria-label="お問い合わせCTA"
    >
      {/* Decorative amber glow */}
      <div
        className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-96 h-96 rounded-full pointer-events-none"
        style={{
          background: 'radial-gradient(circle, rgba(245,166,35,0.12) 0%, transparent 70%)',
        }}
      />

      {/* Tire icon decoration */}
      <div
        className="absolute right-8 md:right-16 top-1/2 -translate-y-1/2 text-9xl md:text-[200px] opacity-5 pointer-events-none select-none"
        aria-hidden="true"
      >
        <i className="ri-tire-line" style={{ color: '#f5a623' }}></i>
      </div>

      <div className="relative z-10 max-w-3xl mx-auto px-4 text-center">
        <p
          className="text-xs font-bold tracking-widest uppercase mb-6"
          style={{ color: '#f5a623', fontFamily: '"Oswald", sans-serif', letterSpacing: '4px' }}
        >
          Contact Us
        </p>
        <h2
          className="text-3xl md:text-5xl font-black text-white mb-5 leading-tight"
          style={{ fontFamily: '"Noto Sans JP", sans-serif' }}
        >
          まずはお電話ください。
        </h2>
        <p
          className="text-base md:text-lg mb-10"
          style={{ color: 'rgba(255,255,255,0.8)', fontFamily: '"Noto Sans JP", sans-serif', lineHeight: '1.9' }}
        >
          サイズや在庫のご確認、お見積りも<strong style={{ color: '#f5a623' }}>無料</strong>です。<br />
          お気軽にお問い合わせください。
        </p>

        {/* Big phone button */}
        <a
          href="tel:08097798744"
          className="inline-flex items-center justify-center gap-4 px-10 md:px-16 py-5 md:py-6 rounded-full font-black text-xl md:text-3xl whitespace-nowrap transition-all duration-200 hover:scale-105 active:scale-100"
          style={{
            backgroundColor: '#ffffff',
            color: '#1a1a1a',
            fontFamily: '"Oswald", sans-serif',
            letterSpacing: '0.05em',
          }}
        >
          <span className="w-8 h-8 flex items-center justify-center">
            <i className="ri-phone-fill text-2xl md:text-3xl" style={{ color: '#f5a623' }}></i>
          </span>
          080-9779-8744
        </a>

        <p
          className="text-xs mt-6"
          style={{ color: 'rgba(255,255,255,0.4)', fontFamily: '"Noto Sans JP", sans-serif' }}
        >
          営業時間 9:00〜18:00（不定期休みのみ・基本年中無休）
        </p>
      </div>
    </section>
  );
}